import { render, staticRenderFns } from "./return_list.vue?vue&type=template&id=00f9fc48&scoped=true"
import script from "./return_list.vue?vue&type=script&lang=js"
export * from "./return_list.vue?vue&type=script&lang=js"
import style0 from "./return_list.vue?vue&type=style&index=0&id=00f9fc48&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f9fc48",
  null
  
)

export default component.exports